import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-register-form-step',
  imports: [
    TranslocoPipe
  ],
  templateUrl: './register-form-step.component.html',
  styleUrl: './register-form-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterFormStepComponent {
  name = input<string>('');
}
